var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90001 15.6478L5.29801 15.8618C6.33001 16.0198 7.06701 16.9438 6.99101 17.9848L6.88801 19.3958C6.85801 19.8068 7.08201 20.1938 7.45301 20.3728L8.48701 20.8708C8.85801 21.0498 9.30101 20.9828 9.60401 20.7038L10.643 19.7438C11.409 19.0358 12.591 19.0358 13.358 19.7438L14.397 20.7038C14.7 20.9838 15.142 21.0498 15.514 20.8708L16.55 20.3718C16.92 20.1938 17.143 19.8078 17.113 19.3978L17.01 17.9848C16.934 16.9438 17.671 16.0198 18.703 15.8618L20.101 15.6478C20.508 15.5858 20.836 15.2808 20.928 14.8788L21.183 13.7608C21.275 13.3588 21.112 12.9418 20.772 12.7098L19.605 11.9108C18.744 11.3208 18.481 10.1688 19.001 9.26375L19.706 8.03775C19.911 7.68075 19.877 7.23375 19.62 6.91175L18.905 6.01475C18.648 5.69275 18.22 5.55975 17.826 5.68075L16.474 6.09475C15.475 6.40075 14.41 5.88775 14.026 4.91675L13.508 3.60375C13.356 3.21975 12.985 2.96775 12.572 2.96875L11.426 2.97175C11.013 2.97275 10.643 3.22675 10.493 3.61175L9.98801 4.90975C9.60801 5.88675 8.53801 6.40375 7.53601 6.09575L6.12801 5.66375C5.73301 5.54175 5.30301 5.67575 5.04601 5.99975L4.33601 6.89775C4.07901 7.22275 4.04801 7.67075 4.25701 8.02775L4.97801 9.25675C5.50901 10.1628 5.24901 11.3258 4.38301 11.9188L3.23001 12.7088C2.89001 12.9418 2.72701 13.3588 2.81901 13.7598L3.07401 14.8778C3.16501 15.2808 3.49301 15.5858 3.90001 15.6478V15.6478Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.916 10.0865C14.974 11.1445 14.974 12.8605 13.916 13.9185C12.858 14.9765 11.142 14.9765 10.084 13.9185C9.02603 12.8605 9.02603 11.1445 10.084 10.0865C11.142 9.02847 12.858 9.02847 13.916 10.0865",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.4af694bb15b85ffb02e04a75076dc9f5.svg";
export { ForwardRef as ReactComponent };